// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tooltip[data-v-2c4495a4]{padding:4px 6px}.div_imgXml[data-v-2c4495a4]{margin:0 auto;width:100%;background:#fff;border-radius:18px;overflow:hidden}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
